module.exports = __webpack_public_path__ + "static/img/img.a6674fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img.jpg
// module id = D9lA
// module chunks = 1